<script>
	import { onMount } from 'svelte';
    import {
        Block,
        Link,
        Card,
        CardHeader,
        CardContent,
        Popup,
        Page,
        Navbar,
        NavRight,
        ListInput,
        List
    } from 'framework7-svelte';
    import { toolsMapInteraction } from '../../components/toolsMap/toolsMap-store'
    import { setToolsMap } from '../../components/toolsMap/toolsMap-data'
    import { treeTools } from '../../components/tree/tree-store'
    import { getBboxView,findEntidad,centerPoint} from '../../tools/mapboxgl/index'
    import * as moment from 'moment';

    let toolsMap; toolsMapInteraction.subscribe(prop=>{toolsMap = prop});
	let search = undefined;
	let users = [];
    let nopagina=1;
    let datosXpagina=10;
    let totopaginas;
    let filtroGeneral=0
    let filtroRegistros=[]
    let statusFilter=false
    let layerFiltro='pcalordia'
    function conteos1(){
        let filter=users.filter(item => {
            function clean(value){
                return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            }
            let estado=clean(item.d2)
            let municipio=clean(item.d3)
            let vegetacion=clean(item.d4)
            search=clean(search)
			return estado.match(`${search}.*`) || municipio.match(`${search}.*`) || vegetacion.match(`${search}.*`)
		})
        nopagina=1
        paginate(filter,datosXpagina,nopagina)
        totopaginas=filter.length>=datosXpagina?Math.ceil(filter.length/datosXpagina):1
        filtroRegistros=filter
        filtroGeneral=filter.length
        statusFilter=true
        return filter
    }
    function conteos2(){
        filtroGeneral=users.length
        statusFilter=false
        return paginate(users,datosXpagina,1)
    }
	$: visibleUsers = search ? conteos1() : conteos2();
    let selected;
    function paginate(array, page_size, page_number) {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }
    function asc(){
        visibleUsers=visibleUsers.sort(function(a, b) {
            return parseFloat(a['d3']) - parseFloat(b['d3']);
        });
    }
	let sortBy = {col: "id", ascending: true};

	$: sort = (column) => {
		if (sortBy.col == column) {
			sortBy.ascending = !sortBy.ascending
		} else {
			sortBy.col = column
			sortBy.ascending = true
		}
		// Modifier to sorting function for ascending or descending
		let sortModifier = (sortBy.ascending) ? 1 : -1;
		let sort = (a, b) =>
			(a[column] < b[column])
			? -1 * sortModifier
			: (a[column] > b[column])
			? 1 * sortModifier
			: 0;
		users = users.sort(sort);
        visibleUsers=paginate(users,datosXpagina,nopagina);
	}
	onMount(async () => {

    })
</script>

<style>
  /*@import url('https://gthomas-appfolio.github.io/bootstrap-coastline/bootstrap-coastline.css');*/
</style>
<Link popupOpen=".demo-popup-infoTable" style="margin-top: 5px;margin-left: 5px;color:{$toolsMapInteraction[0]['statusTable']?'dodgerblue':'white'}" iconSize="22px" tooltip="Información de P. Calor" iconIos="f7:table_badge_more" iconAurora="f7:table_badge_more" iconMd="f7:table_badge_more"
      on:click={()=>{
        setToolsMap('statusTable',!$toolsMapInteraction[0]['statusTable'])
}}/>
<Popup onPopupOpen={() => {
    getBboxView(layerFiltro)
    //users=$toolsMapInteraction[0]['pointsBbox']
    users=getBboxView(layerFiltro)
    filtroGeneral=users.length
    visibleUsers=paginate(users,datosXpagina,1)
    totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
    sortBy['ascending']=false
    sort("d2")
    //users=paginate(users, 10, 1)
}
} onPopupClosed={() => $toolsMapInteraction[0]['statusTable'] = false} class="demo-popup-infoTable"
tabletFullscreen themeDark swipeToClose>
<Page>
    <Navbar title="Información de puntos de calor seleccionados por área y fecha">
    <NavRight>
        <Link popupClose panelClose>Close</Link>
    </NavRight>
    </Navbar>
    <Block>
    <Card>
        <CardHeader>
            <div class="input">
                <input type="text" placeholder="Ingresar Filtro"
                bind:value={search}
                />
            </div>
        </CardHeader>
        <CardContent style="padding-top: 0px;" outline={false}>
        <div class="card data-table" style="margin-top: 0px;">
            <div style="float:left;">
                <p style="margin-top: 35px;color: var(--f7-table-footer-text-color);font-size: var(--f7-table-footer-font-size);">
                    Registros
                    <Link style="margin-top: 15px;"
                    iconSize="18px"
                    tooltip="{`
                        <span style="color:white">No afecta área natural<br></span>
                        <span style="color:yellow">Cerca de área natural (< 5km)<br></span>
                        <span style="color:red">Dentro de área natural<br></span>
                    `}"
                    iconIos="f7:info_circle_fill" iconAurora="f7:info_circle_fill" iconMd="f7:info_circle_fill"
                    on:click={()=>{

                    }}/>
                </p>
                {#if $treeTools.find(item =>item.id===4)!==undefined?$treeTools.find(item =>item.id===4)['selected']:false || $treeTools.find(item =>item.id===32)!==undefined?$treeTools.find(item =>item.id===32)['selected']:false}
               
                <List inlineLabels noHairlinesMd>
                    <ListInput
                        label="Capa"
                        type="select"
                        inputStyle="width: 120px;"
                        bind:value={layerFiltro}
                        resizable={true}
                        on:change={async ()=>{
                            if(layerFiltro==='pcalordia'){
                                users=getBboxView(layerFiltro)
                                filtroGeneral=users.length
                                visibleUsers=paginate(users,datosXpagina,1)
                                totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
                                sortBy['ascending']=false
                                sort("d2")
                                nopagina=1
                                totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
                                visibleUsers=statusFilter?paginate(filtroRegistros, datosXpagina,nopagina):paginate(users, datosXpagina,nopagina)
                            }else{
                                layerFiltro='pcalorfiltro'
                                users=getBboxView(layerFiltro)
                                filtroGeneral=users.length
                                visibleUsers=paginate(users,datosXpagina,1)
                                totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
                                sortBy['ascending']=false
                                sort("d2")
                                nopagina=1
                                totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
                                visibleUsers=statusFilter?paginate(filtroRegistros, datosXpagina,nopagina):paginate(users, datosXpagina,nopagina)
                            }
                        }}
                        placeholder="Please choose..."
                        >
                        <i class="icon demo-list-icon" slot="media"/>
                        {#if $treeTools.find(item =>item.id===4)!==undefined?$treeTools.find(item =>item.id===4)['selected']:false}
                        <option selected={layerFiltro==='pcalordia'?true:false} value="pcalordia">P. Calor día</option>
                        {/if}
                        {#if $treeTools.find(item =>item.id===32)!==undefined?$treeTools.find(item =>item.id===32)['selected']:false}
                        <option selected={layerFiltro==='pcalorfiltro'?true:false} value="pcalorfiltro">P. Calor 3 meses</option>
                        {/if}
                    </ListInput>
                </List>
                {:else}
                <p style="color: var(--f7-table-footer-text-color);font-size: var(--f7-table-footer-font-size);">
                    Seleccionar la capa de puntos de calor o haz un cunsulta "filtro de 3 meses"
                </p>

                {/if}
            </div>
            <div class="data-table-footer">
                <div class="data-table-rows-select">
                    <p style="margin-right: 25px;text-align: center;">
                        Mostrando registros del<br>
                        {nopagina===1?nopagina:(visibleUsers.length*(nopagina-1))+1} al {((datosXpagina)*(nopagina-1))+parseInt(datosXpagina)<=users.length?((datosXpagina)*(nopagina-1))+parseInt(datosXpagina):users.length}<br>
                        de un total de {filtroGeneral} <br>
                        Puntos de calor
                    </p>
                </div>
                <div class="data-table-rows-select">
                    Por pagina:
                    <div class="input input-dropdown">
                        <select
                            bind:value={datosXpagina}
                            on:change={() => {
                                nopagina=1
                                totopaginas=users.length>=datosXpagina?Math.ceil(users.length/datosXpagina):1
                                visibleUsers=statusFilter?paginate(filtroRegistros, datosXpagina,nopagina):paginate(users, datosXpagina,nopagina)
                            }}>
                            <option value="5">5</option>
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="{users.length}">All</option>
                        </select>
                    </div>
                </div>
                <div class="data-table-pagination">
                <span class="data-table-pagination-label">
                    Página {nopagina} de {totopaginas}
                </span>
                <a href="#" class="link {nopagina===1?'disabled':''}" on:click={() => {
                    nopagina=nopagina-1
                    visibleUsers=statusFilter?paginate(filtroRegistros, datosXpagina,nopagina):paginate(users, datosXpagina,nopagina)
                    }}>
                    <i class="icon icon-prev color-gray"></i>
                </a>
                <a href="#" class="link {totopaginas<=nopagina?'disabled':''}" on:click={() => {
                    if(totopaginas>=nopagina){
                        nopagina=nopagina+1
                        visibleUsers=statusFilter?paginate(filtroRegistros, datosXpagina,nopagina):paginate(users, datosXpagina,nopagina)
                    }
                    }}>
                    <i class="icon icon-next color-gray"></i>
                </a>
                </div>
            </div>
                <table>
                    <thead>
                    <tr>
                        <th class="label-cell">
                            <span class="table-head-label">No. reg.</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='id'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                            on:click={()=>{
                                sort("id")
                            }}
                            >
                            <span class="table-head-label">Id P. calor</span>
                        </th>
                        <th class="label-cel">
                            <span class="table-head-label">Lat/Lon</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d1'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                            on:click={()=>{
                                sort("d1")
                            }}
                            >
                            <span class="table-head-label">País</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d2'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                            on:click={()=>{
                                sort("d2")
                            }}
                            >
                            <span class="table-head-label">Estado</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d3'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d3")
                         }}
                        >
                            <span class="table-head-label">Municipio</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d4'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d4")
                         }}
                        >
                        <span class="table-head-label">Vegetación</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d5'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d5")
                         }}
                        >
                        <span class="table-head-label">Área natural afectada</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d6'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d6")
                         }}
                        >
                        <span class="table-head-label">Pendiente</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d9'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d9")
                         }}
                        >
                        <span class="table-head-label">Satélite</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='fecha'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("fecha")
                         }}
                        >
                        <span class="table-head-label">Fecha</span>
                        </th>
                        <th class="label-cell sortable-cell {sortBy.col==='d10'?sortBy.ascending?'sortable-cell-active sortable-desc':'sortable-cell-active sortable-asc':''}"
                         on:click={()=>{
                            sort("d10")
                         }}
                        >
                        <span class="table-head-label">Hora</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        {#each visibleUsers as { d1, d2,d3,d4,d5,d6,d9,fecha,d8,d10,id,lat,lon,coordinates,idpoint,source }, i}
                            <tr style="color:{d5==='no afecta anp'?'white':d5.includes(`cerca`)?'yellow':'red'};">
                                {#if datosXpagina!=users.length}
                                    <td>{nopagina==1?i+1:(i+1)+datosXpagina*(nopagina-1)}</td>
                                {:else}
                                    <td>{i+1}</td>
                                {/if}
                                <td>
                                    <Link href="#"
                                        popupClose=".demo-popup-infoTable"
                                        tooltip="Ver en Mapa"
                                        on:click={()=>{
                                            centerPoint(lon,lat,13)
                                            findEntidad(source,idpoint)
                                        }}
                                        >{id}
                                    </Link>
                                </td>
                                <td>{lat},{lon}</td>
                                <td>{d1}</td>
                                <td>{d2}</td>
                                <td>{d3}</td>
                                <td>{d4}</td>
                                <td>{d5}</td>
                                <td>{d6}</td>
                                <td>{d9}</td>
                                <td>{moment.unix(d10).format('DD-MM-YYYY')}</td>
                                <td>{moment.unix(d10).format('HH:mm:ss')}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>

            </div>
        </CardContent>
    </Card>
    </Block>

</Page>
</Popup>
